import request from '@/utils/request'

/**
 * 查询资源库列表
 * @param {Object} params 
 * @returns 
 */
export function listResourceLibrary(data) {
  return request({
    url: '/resource_library/list',
    method: 'POST',
    data,
  })
}

/**
 * 查询资源库列表(不分页)
 * @param {Object} params 
 * @returns 
 */
export function allResourceLibrary(data) {
  return request({
    url: '/resource_library/allList',
    method: 'POST',
    data,
  })
}

/**
 * 添加资源库列表
 * @param {Object} data 
 * @returns 
 */
export function addResourceLibrary(data) {
  return request({
    url: '/resource_library/add',
    method: 'POST',
    data,
  })
}


/**
 * 修改资源库列表
 * @param {Object} data 
 * @returns 
 */
export function updateResourceLibrary(data) {
  return request({
    url: '/resource_library/update',
    method: 'PUT',
    data,
  })
}


/**
 * 删除资源库列表
 * @param {Object} data 
 * @returns 
 */
export function delResourceLibrary(data) {
  return request({
    url: '/resource_library/delete',
    method: 'DELETE',
    data,
  })
}


/**
 * 查询资源库列表所有
 * @param {Object} params 
 * @returns 
 */
export function listResourceLibraryAll(data) {
  return request({
    url: '/resource_library/listall',
    method: 'POST',
    data,
  })
}
